import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { getBackendUrl } from "../utils/backendUrl";
import { Sparkles, Check } from "lucide-react";

export default function PaywallPage() {
  const { token, logout } = useAuth();
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const lang = localStorage.getItem("beauly_lang") || "en";
      const res = await fetch(`${getBackendUrl()}/payments/create-checkout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ locale: lang }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const features = [
    t("paywall_feature_1") || "KI-Analyse deines Gesichts",
    t("paywall_feature_2") || "Realistische Vorher/Nachher Visualisierung",
    t("paywall_feature_3") || "Persönlicher Styling-Plan",
  ];

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 font-sans">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Beauly" className="h-16 object-contain mx-auto mb-3" />
          <h1 className="font-display text-3xl text-primary">Beauly</h1>
        </div>

        {/* Card */}
        <div className="rounded-2xl border border-surface-border bg-surface p-8 text-center">
          <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-4">
            <Sparkles size={24} className="text-accent-dark" />
          </div>

          <h2 className="font-display text-xl text-primary mb-1">
            {t("paywall_title") || "Schalte Beauly frei"}
          </h2>
          <p className="text-text-muted text-sm mb-6">
            {t("paywall_desc") || "Einmalzahlung — kein Abo, keine versteckten Kosten."}
          </p>

          {/* Price */}
          <div className="mb-6">
            <span className="font-display text-5xl text-primary">6,50€</span>
            <span className="text-text-muted text-sm ml-2">{t("paywall_period") || "/ Monat"}</span>
          </div>

          {/* Features */}
          <ul className="text-left space-y-3 mb-8">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-text-secondary">
                <Check size={16} className="text-accent-dark flex-shrink-0 mt-0.5" />
                <span>{f}</span>
              </li>
            ))}
          </ul>

          {/* CTA */}
          <button
            onClick={handleCheckout}
            disabled={loading}
            className="w-full py-3.5 bg-primary text-white rounded-xl font-medium text-base hover:bg-primary-600 transition-all duration-300 disabled:opacity-50"
          >
            {loading ? "..." : t("paywall_cta") || "Jetzt freischalten"}
          </button>
        </div>

        {/* Logout link */}
        <p className="text-center mt-4">
          <button onClick={logout} className="text-text-muted text-xs hover:text-primary transition-colors">
            {t("paywall_logout") || "Abmelden"}
          </button>
        </p>
      </div>
    </div>
  );
}
